import React, { Component } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import PropTypes from "prop-types";

const scoreColors = {
	1: { bg: "#ff262a", text: "#fff" },
	2: { bg: "#ffb607", text: "#000" },
	3: { bg: "#ffff2f", text: "#000" },
	4: { bg: "#00ff55", text: "#000" },
	5: { bg: "#00bc2a", text: "#fff" },
};

export default class ScoreIndicator extends Component {

	constructor(props) {
		super(props);

		this.state = {
			labelExplanation: this.getLabelExplanation(this.props.label, this.props.position),
		};
	}

	wrapWithTooltip = (component, text, key) => {
		if (text) {
			return (
				<OverlayTrigger
					key={key}
					placement="left"
					overlay={<Tooltip id="bar-tooltip">{text}</Tooltip>}
				>
					{component}
				</OverlayTrigger>
			);
		}

		return component;
	}

	getLabelExplanation = (label, position) => {
		let explanation = ""
		let explanationPDF = ""
		switch (position) {
			case 1:
				explanation = <span><b>{"Muy baja"}</b>{" probabilidad de cumplir con obligaciones crediticias"}</span>
				explanationPDF = "Muy baja probabilidad de cumplir con obligaciones crediticias"
				break;

			case 2:
				explanation = <span><b>{"Baja"}</b>{" probabilidad de cumplir con obligaciones crediticias"}</span>
				explanationPDF = "Baja probabilidad de cumplir con obligaciones crediticias"
				break;

			case 3:
				explanation = <span>{"Probabilidad "}<b>{"media"}</b>{" de cumplir con obligaciones crediticias"}</span>
				explanationPDF = "Probabilidad media de cumplir con obligaciones crediticias"
				break;

			case 4:
				explanation = <span><b>{"Alta"}</b>{" probabilidad de cumplir con obligaciones crediticias"}</span>
				explanationPDF = "Alta probabilidad de cumplir con obligaciones crediticias"
				break;

			case 5:
				explanation = <span><b>{"Muy alta"}</b>{" probabilidad de cumplir con obligaciones crediticias"}</span>
				explanationPDF = "Muy alta probabilidad de cumplir con obligaciones crediticias"
				break;
		}

		// Envío el valor de la explicación al parent para PDF
		this.props.updateScoreExplanationPdf(explanationPDF);

		return explanation
	}

	render() {
		return (
			<div
				style={{
					display: "flex",
					alignItems: "center",
					gap: "1rem",
					marginBottom: "2rem",
				}}
			>
				<div style={{ display: "flex", minWidth: "170px" }}>
					{[1, 2, 3, 4, 5].map((box) => {
						const isCurrent = box === this.props.position;

						return this.wrapWithTooltip(
							<div
								style={{
									position: "relative",
									height: "20px",
									width: "20%",
									lineHeight: 1,
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									backgroundColor: scoreColors[box].bg,
									color: scoreColors[box].text,
									transform: isCurrent
										? "scale(1.6,1.6)"
										: "none",
									boxShadow: isCurrent
										? "0px 0px 5px 1px rgba(0,0,0,0.2)"
										: "none",
									borderRadius: isCurrent ? "2px" : "none",
									opacity: !isCurrent ? ".5" : "1",
									zIndex: isCurrent ? "2" : "1",
								}}
							>
								{isCurrent && (
									<strong
										style={{
											padding: "1rem",
											fontSize: "7px",
											textAlign: "center",
										}}
									>
										{this.props.label}
									</strong>
								)}
							</div>,
							isCurrent ? this.props.legend : null,
							box
						);
					})}
				</div>
				<div style={{
					marginLeft: "1em"
				}}
				>
					{this.state.labelExplanation}
				</div>
			</div>
		);
	}
}

ScoreIndicator.propTypes = {
	position: PropTypes.number,
	label: PropTypes.string,
	legend: PropTypes.string,
	updateScoreExplanationPdf: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/scenes/personas/components/personas-detalle/components/panel-veraz/components/ScoreIndicator.js